import { gql } from '@apollo/client';
import type { VehicleTag } from '../../__generated__/graphql';
import graphQLRequester from '../../request/GraphQLRequester';

export class GraphQLVehicleTagsRequester {
  public getVehicleTags = (): Promise<VehicleTag[]> => {
    return graphQLRequester
      .query<{ vehicleTags: VehicleTag[] }>({
        query: gql`
          query vehicleTags {
            vehicleTags {
              name
            }
          }
        `,
      })
      .then((graphQlResponse) => graphQlResponse.vehicleTags);
  };

  public deleteVehicleTag = (name: string): Promise<string> => {
    return graphQLRequester
      .mutate<{ deleteVehicleTag: string }>({
        mutation: gql`
          mutation DeleteVehicleTag($name: String!) {
            deleteVehicleTag(name: $name)
          }
        `,
        variables: { name },
      })
      .then((result) => result.deleteVehicleTag);
  };
}

export default GraphQLVehicleTagsRequester;
